import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { PlacementAuthService } from '../placement-auth-service/placement-auth.service';

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  private http: HttpClient;

  constructor(private handler: HttpBackend, private placementAuthService: PlacementAuthService) {
    // Using HttpBackend to bypass generic interceptors that might overwrite placement headers
    this.http = new HttpClient(handler);
  }

  getFacilityDetails(facilityId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/facilities/${facilityId}`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getAllAmenities(facilityTypeId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/amenities?facility_type=${facilityTypeId}&amenities_type=1`, { headers });
      }),
      catchError(errorHandl)
    );
  }

  getFacilityAmenities(facilityId: number | string): Observable<any> {
    return this.placementAuthService.login().pipe(
      switchMap(token => {
        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`
        });
        return this.http.get<any>(`${this.placementAuthService.baseUrl}/amenities/facility?id=${facilityId}`, { headers });
      }),
      catchError(errorHandl)
    );
  }
}
